<!-- <app-full-layout></app-full-layout> -->
<app-main-header></app-main-header>
<router-outlet></router-outlet>
<!-- <h1>{{ message }}</h1> -->
<!-- *ngIf="message && message.notification" -->
<!-- <div class="notify">
  <div class="card-title">New Message</div>
  <div class="card-body">
   <h2>{{ message.notification.body }}</h2> 

    hehehe
  </div>
</div> -->

<div class="notify">
  <div class="card-title ml-2" style="color: white">
    {{ message?.title }}
  </div>
  <div class="card-body">{{ message?.body }}</div>
</div>
